import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import api from '../api';
import { clearResults } from '../actions/search';
import {
  searchResultsSelector,
  searchGetLoadingSelector
} from '../selectors/search';
import { Search as SearchIcon } from './icons';
import './Search.css';
import { formatContentForReact } from './globalHelpers';

const Search = props => {
  const {
    searchGet,
    searchResults,
    searchLoading,
    history,
    menuClose,
    clearResults
  } = props;

  const [selection, setSelection] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    const handleSearch = () => {
      setSearchTerm(searchTerm);
    };

    const handleSearchDebounced = debounce(handleSearch, 250);
    window.addEventListener('search', handleSearchDebounced);

    if (searchTerm && searchTerm.length > 2) {
      searchGet(searchTerm);
      setShowResults(true);
    }

    return () => window.removeEventListener('search', handleSearchDebounced);
  }, [searchGet, searchTerm]);

  const handleResultClick = () => {
    // for mobile search only
    if (menuClose) {
      menuClose();
    }
    setShowResults(false);
    setSearchTerm('');
  };

  const handleArrowPress = modifier => {
    const numberOfResults = searchResults.length;
    const newSelection = selection + modifier;
    setSelection(
      newSelection >= numberOfResults || newSelection < 0 ? -1 : newSelection
    );
  };

  const handleKeyPress = event => {
    const { key } = event;
    switch (key) {
      case 'ArrowDown':
        handleArrowPress(1);
        break;
      case 'ArrowUp':
        handleArrowPress(-1);
        break;
      default:
        break;
    }
  };

  const handleOnFocus = () => {
    if (searchTerm.length < 3) {
      clearResults();
      setSelection(-1);
    }
    setShowResults(true);
  };

  const handleOnSubmit = event => {
    event.preventDefault();

    if (selection !== -1) {
      const choice = searchResults[selection];
      history.push(choice.path);
      setShowResults(false);
    }
  };

  const handleOnBlur = e => {
    setTimeout(() => {
      if (!e.relatedTarget) {
        return setShowResults(false);
      }
      return setShowResults(e.relatedTarget.className.match(/form-search/));
    }, 250);
  };

  return (
    <form onSubmit={handleOnSubmit} name="searchForm" autoComplete="off">
      <div className="form-search">
        <input
          className="form-search__input"
          name="searchQuery"
          type="search"
          onChange={e => setSearchTerm(e.target.value)}
          onBlur={e => handleOnBlur(e)}
          onFocus={handleOnFocus}
          value={searchTerm || ''}
          placeholder="Search..."
          onKeyDown={handleKeyPress}
        />
        <SearchIcon width="32" height="32" viewBox="0 0 32 32" />
        {searchResults.length > 0 && showResults && (
          <ul className="form-search__results">
            {searchResults.map((result, index) => (
              <li key={result.title} className="form-search__result">
                <Link
                  to={result.link}
                  onClick={handleResultClick}
                  className={`form-search__result-link ${
                    index === selection ? 'selected' : ''
                  }`}
                  tabIndex="0"
                >
                  {formatContentForReact(result.title)}
                  {formatContentForReact(result.subtitle)}
                </Link>
              </li>
            ))}
          </ul>
        )}
        {searchLoading && searchTerm.length > 2 && (
          <ul className="form-search__results">
            <li className="form-search__result">Loading ...</li>
          </ul>
        )}
      </div>
    </form>
  );
};

Search.propTypes = {
  clearResults: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  searchResults: PropTypes.arrayOf(PropTypes.shape()),
  searchGet: PropTypes.func,
  searchLoading: PropTypes.bool,
  menuClose: PropTypes.func
};

Search.defaultProps = {
  clearResults: () => {},
  history: {},
  searchGet: () => {},
  searchResults: [],
  searchLoading: true,
  menuClose: () => {}
};

const mapStateToProps = state => ({
  searchResults: searchResultsSelector(state),
  searchLoading: searchGetLoadingSelector(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      searchGet: term => api.actions.searchGet({ term }),
      clearResults
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search));



// WEBPACK FOOTER //
// ./src/components/Search.js